if (typeof globalThis.FormsV2ReferenceTables === "undefined") {
    Object.defineProperty(globalThis, "FormsV2ReferenceTables", {
        value: {},
        enumerable: false,
        configurable: true,
        writable: true,
    });
}
// Each loaded form will have it's own reference table
// this is where we store them
export const referenceTables = globalThis.FormsV2ReferenceTables;
export function removeReferenceTable(modelKey) {
    delete referenceTables[modelKey];
}
export function removeAllReferenceTables() {
    for (const key of Object.keys(referenceTables)) {
        delete referenceTables[key];
    }
}
//# sourceMappingURL=reference-tables.js.map